export default "__VITE_ASSET__DRwwtL8T__"